// @ts-nocheck
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import {
  ArrowRightIcon,
  Bars3Icon,
  CheckCircleIcon,
  ClockIcon,
  CreditCardIcon,
  DocumentChartBarIcon,
  LinkIcon,
  MapPinIcon,
  ShieldCheckIcon,
  SparklesIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';

import euformsLogo from '../../images/euforms.png';
import formIllustration from '../../images/landingpage.svg';
import productPreview from '../../images/formlanding.png';

import LanguageSelector from '../../components/LanguageSelector';


const features = [
  {
    title: 'Pagamentos integrados',
    text: 'MB WAY, Multibanco e cartão diretamente nos seus formulários.',
    icon: CreditCardIcon,
  },
  {
    title: 'Partilha instantânea',
    text: 'Publique e partilhe cada formulário através de um endereço único.',
    icon: LinkIcon,
  },
  {
    title: 'Respostas organizadas',
    text: 'Consulte dados e pagamentos numa área centralizada e simples.',
    icon: DocumentChartBarIcon,
  },
  {
    title: 'Localização de eventos',
    text: 'Inclua coordenadas e ajude os participantes a chegar ao destino.',
    icon: MapPinIcon,
  },
  {
    title: 'Tudo em tempo real',
    text: 'Crie, publique e acompanhe respostas sem processos complicados.',
    icon: ClockIcon,
  },
  {
    title: 'Seguro por natureza',
    text: 'A infraestrutura Eupago protege os dados e os pagamentos.',
    icon: ShieldCheckIcon,
  },
];


const steps = [
  [
    '01',
    'Crie a sua conta',
    'Ligue a sua conta Eupago à plataforma Formulários em poucos minutos.',
  ],
  [
    '02',
    'Desenhe o formulário',
    'Escolha campos, pagamentos, stock e regras sem escrever código.',
  ],
  [
    '03',
    'Partilhe e acompanhe',
    'Envie o link e consulte respostas e referências em tempo real.',
  ],
];


export default function IndexLanding() {

  const [menuOpen, setMenuOpen] = useState(false);


  return (

      <div className="landing-page">

        {/* HERO */}
        <section className="landing-hero">

          <div className="landing-grid-overlay" />


          {/* HEADER */}
          <header className="landing-header">

            <a
                href="https://www.eupago.pt"
                className="landing-logo"
                aria-label="Eupago"
            >
              <img
                  src={euformsLogo}
                  alt="Formulários"
              />
            </a>


            {/* DESKTOP NAV */}
            <nav
                className="landing-nav"
                aria-label="Navegação principal"
            >

              <a href="#vantagens">
                Vantagens
              </a>

              <a href="#como-funciona">
                Como funciona
              </a>

              <a href="https://www.eupago.pt/faqs">
                Ajuda
              </a>


              {/* IDIOMA */}
              <LanguageSelector compact />


              <Link
                  to="/login"
                  className="landing-login"
              >
                Entrar
              </Link>


              <Link
                  to="/register"
                  className="landing-nav-cta"
              >
                Criar conta
              </Link>

            </nav>


            {/* MOBILE MENU BUTTON */}
            <button
                className="landing-menu"
                type="button"
                onClick={() => setMenuOpen(!menuOpen)}
                aria-label="Abrir menu"
            >

              {menuOpen
                  ? <XMarkIcon />
                  : <Bars3Icon />
              }

            </button>

          </header>


          {/* MOBILE NAV */}
          {menuOpen && (

              <nav className="landing-mobile-nav">

                <a
                    href="#vantagens"
                    onClick={() => setMenuOpen(false)}
                >
                  Vantagens
                </a>


                <a
                    href="#como-funciona"
                    onClick={() => setMenuOpen(false)}
                >
                  Como funciona
                </a>


                <a href="https://www.eupago.pt/faqs">
                  Ajuda
                </a>


                {/* IDIOMA MOBILE */}
                <LanguageSelector compact />


                <Link
                    to="/login"
                    onClick={() => setMenuOpen(false)}
                >
                  Entrar
                </Link>


                <Link
                    to="/register"
                    className="landing-nav-cta"
                    onClick={() => setMenuOpen(false)}
                >
                  Criar conta
                </Link>

              </nav>

          )}


          {/* HERO CONTENT */}
          <div className="landing-hero-inner">

            <div className="landing-hero-copy">

              <a
                  href="https://www.eupago.pt/registo"
                  className="landing-pill"
              >

                <SparklesIcon />

                Ainda não é cliente Eupago?

                <span>
                Saiba mais
              </span>

                <ArrowRightIcon />

              </a>


              <h1>
                Formulários inteligentes.
                <br />

                <span>
                Pagamentos sem esforço.
              </span>
              </h1>


              <p>
                Crie experiências profissionais, recolha respostas e receba
                pagamentos através de uma plataforma simples, integrada
                diretamente com a Eupago.
              </p>


              <div className="landing-actions">

                <Link
                    to="/register"
                    className="landing-primary-button"
                >
                  Criar o primeiro formulário
                  <ArrowRightIcon />
                </Link>


                <Link
                    to="/login"
                    className="landing-secondary-button"
                >
                  Já tenho conta
                </Link>

              </div>


              <div className="landing-trust-row">

              <span>
                <CheckCircleIcon />
                Configuração rápida
              </span>


                <span>
                <CheckCircleIcon />
                Sem custos de utilização
              </span>


                <span>
                <CheckCircleIcon />
                Tecnologia Eupago
              </span>

              </div>

            </div>


            {/* HERO VISUAL */}
            <div
                className="landing-visual"
                aria-label="Pré-visualização da plataforma Formulários"
            >

              <div className="landing-visual-glow" />


              <div className="landing-floating-card landing-card-top">

              <span>
                Respostas hoje
              </span>

                <strong>
                  +24
                </strong>

              </div>


              <div className="landing-illustration-card">

                <img
                    src={formIllustration}
                    alt="Pessoas a criar um formulário"
                />

              </div>


              <div className="landing-floating-card landing-card-bottom">

                <CreditCardIcon />

                <div>

                <span>
                  Pagamentos
                </span>

                  <strong>
                    Integrados
                  </strong>

                </div>

              </div>

            </div>

          </div>

        </section>


        {/* PROOF */}
        <section
            className="landing-proof"
            aria-label="Destaques"
        >

          <div>
            <strong>
              Minutos
            </strong>

            <span>
            para publicar
          </span>
          </div>


          <div>
            <strong>
              6+
            </strong>

            <span>
            tipos de formulário
          </span>
          </div>


          <div>
            <strong>
              3
            </strong>

            <span>
            pagamentos digitais
          </span>
          </div>


          <div>
            <strong>
              24/7
            </strong>

            <span>
            sempre disponível
          </span>
          </div>

        </section>


        {/* PRODUCT */}
        <section className="landing-product-section">

          <div className="landing-section-heading">

          <span>
            Simples por fora. Poderoso por dentro.
          </span>

            <h2>
              Da ideia ao formulário publicado, sem complicações.
            </h2>

            <p>
              Uma área de trabalho clara para construir, gerir e acompanhar
              tudo o que importa.
            </p>

          </div>


          <div className="landing-product-frame">

            <div className="landing-browser-bar">

              <i />
              <i />
              <i />

              <span>
              euforms.eupago.pt
            </span>

            </div>


            <img
                src={productPreview}
                alt="Área de gestão de formulários"
            />

          </div>

        </section>


        {/* FEATURES */}
        <section
            id="vantagens"
            className="landing-features-section"
        >

          <div className="landing-section-heading landing-section-heading-light">

          <span>
            Uma plataforma completa
          </span>


            <h2>
              Tudo o que precisa para criar melhores formulários.
            </h2>


            <p>
              Ferramentas práticas, segurança Eupago e uma experiência
              pensada para equipas de qualquer dimensão.
            </p>

          </div>


          <div className="landing-feature-grid">

            {features.map(({
                             title,
                             text,
                             icon: Icon,
                           }) => (

                <article
                    key={title}
                    className="landing-feature-card"
                >

                  <div className="landing-feature-icon">
                    <Icon />
                  </div>


                  <h3>
                    {title}
                  </h3>


                  <p>
                    {text}
                  </p>

                </article>

            ))}

          </div>

        </section>


        {/* STEPS */}
        <section
            id="como-funciona"
            className="landing-steps-section"
        >

          <div className="landing-steps-copy">

          <span>
            Começar é simples
          </span>


            <h2>
              Três passos entre a ideia e a primeira resposta.
            </h2>


            <p>
              A plataforma Formulários elimina configuração desnecessária para que se
              concentre no conteúdo e nos seus clientes.
            </p>


            <Link
                to="/register"
                className="landing-primary-button"
            >
              Começar agora
              <ArrowRightIcon />
            </Link>

          </div>


          <div className="landing-steps-list">

            {steps.map(([
                          number,
                          title,
                          text,
                        ]) => (

                <div
                    className="landing-step"
                    key={number}
                >

                  <strong>
                    {number}
                  </strong>


                  <div>

                    <h3>
                      {title}
                    </h3>


                    <p>
                      {text}
                    </p>

                  </div>

                </div>

            ))}

          </div>

        </section>


        {/* FINAL CTA */}
        <section className="landing-final-cta">

          <div>

          <span>
            Pronto para começar?
          </span>


            <h2>
              O seu próximo formulário pode estar online hoje.
            </h2>

          </div>


          <Link
              to="/register"
              className="landing-light-button"
          >
            Criar conta gratuita
            <ArrowRightIcon />
          </Link>

        </section>


        {/* FOOTER */}
        <footer className="landing-footer">

          <img
              src={euformsLogo}
              alt="Formulários"
          />


          <p>
            Formulários e pagamentos com tecnologia Eupago.
          </p>


          <div>

            <a href="https://www.eupago.pt">
              Eupago
            </a>

            <a href="https://www.eupago.pt/faqs">
              Ajuda
            </a>

            <a href="https://www.eupago.pt/politica-de-privacidade">
              Privacidade
            </a>

          </div>


          <small>
            © {new Date().getFullYear()} Eupago. Todos os direitos reservados.
          </small>

        </footer>

      </div>

  );

}